import { render, staticRenderFns } from "./SuccessBloc.vue?vue&type=template&id=535894bb"
import script from "./SuccessBloc.vue?vue&type=script&lang=js"
export * from "./SuccessBloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports